

























import Vue from 'vue';
import WizardComponent from '../components/wizard.component.vue';
import NewCircleComponent from '@/components/new-circle.component.vue';
import { Viewport } from '@/utils/enums';

export default Vue.extend({
  name: 'header-component',
  components: {
    WizardComponent,
    NewCircleComponent
  },
  computed: {
    headerLayout() {
      return this.$route.meta.layout.header;
    },
    isBackbuttonVisible() {
      return this.$route.meta.pageLevel > 1 && this.$mq !== Viewport.DESKTOP;
    },
    isMenuVisible() {
      const headerLayout = this.$route.meta.layout.header;

      return headerLayout.menuVisible && this.$mq !== Viewport.DESKTOP;
    }
  },
  methods: {
    onBackClick() {
      // the route link have a replace tag, so the navigation will not leave a history record
      this.$router.back();
    },
    onMenuClick() {
      this.$emit('menuClick');
    }
  }
});
